import brandTheme from '../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const styles = {
  wrapper: {
    margin: '20px 0',
  },
  formControl: {
    width: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  item: {
    width: '100%',
    margin: '0 !important',
    padding: '0 16px 0 5px',
  },
  label: {
    display: 'block',
    padding: 0,
    textAlign: 'left',
    lineHeight: '24px',
    fontSize: '16px',
    color: colors.secondary,
  },
}



// WEBPACK FOOTER //
// ./src/Components/Form/SelectMultiple/styles.js